import { CostCenterBudgetHistoryEntry } from './CostCenterBudgetHistory';

export interface CostCenter {
  id: number;
  code: string;
  name: string;
  description?: string;
  type: string; // Receita, Despesa, etc.
  status: string; // Ativo, Inativo
  parentId?: number | null;
  isActive: boolean;
  /** Legado / formulário — espelha orçamento mensal quando a API não envia `budget`. */
  budget?: number;
  monthlyBudget?: number;
  annualBudget?: number;
  actualCost?: number;
  responsible?: string;
  managerStaffId?: number;
  managerStaffName?: string;
  category?: string;
  branch?: string;
  acceptsCosts?: boolean;
  acceptsRevenues?: boolean;
  currencyCode?: string;
  department?: string;
  startDate?: string;
  endDate?: string;
  notes?: string;
  level?: number; // Nível hierárquico
  path?: string; // Caminho completo na hierarquia
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
  // Dados hierárquicos
  parentName?: string;
  hasChildren?: boolean;
  children?: CostCenter[];
  /** Histórico embutido em GET por código/id (quando a API envia). */
  budgetHistories?: CostCenterBudgetHistoryEntry[];
}

export type CostCenterCreate = Omit<CostCenter, 'id' | 'createdAt' | 'updatedAt' | 'level' | 'path' | 'parentName' | 'hasChildren' | 'children'>;
export type CostCenterUpdate = Partial<CostCenterCreate>;

export interface CostCenterHierarchy {
  id: number;
  code: string;
  name: string;
  level: number;
  children: CostCenterHierarchy[];
}

// Novos endpoints - Validação Circular
export interface CircularReferenceValidation {
  costCenterId: number;
  parentId: number;
  hasCircularReference: boolean;
  isValid: boolean;
  message: string;
}

// Novos endpoints - Custo Consolidado
export interface ConsolidatedCost {
  costCenterId: number;
  costCenterName: string;
  costCenterCode: string;
  consolidatedCost: number;
  actualCost: number;
  description: string;
}

// Novos endpoints - Orçamento Consolidado
export interface ConsolidatedBudget {
  costCenterId: number;
  costCenterName: string;
  costCenterCode: string;
  consolidatedBudget: number;
  monthlyBudget: number;
  annualBudget: number;
  description: string;
}

// Novos endpoints - Estatísticas Consolidadas
export interface CostCenterStatistic {
  costCenterId: number;
  budget: number;
  cost: number;
  variance: number;
  status: 'OK' | 'ATENÇÃO' | 'CRÍTICO';
}

export interface ConsolidatedStatistics {
  totalCostCenters: number;
  statistics: CostCenterStatistic[];
  summary: {
    totalBudget: number;
    totalCost: number;
    overBudgetCount: number;
  };
  /** Aviso da API (ex.: não somar pai + filhos para total). */
  warning?: string;
}

// Novos endpoints - Descendentes
export interface CostCenterDescendant {
  id: number;
  code: string;
  name: string;
  description?: string;
  type: string;
  category?: string;
  department?: string;
  parentCostCenterId?: number;
  isActive: boolean;
  actualCost?: number;
  monthlyBudget?: number;
}

export interface DescendantsResponse {
  costCenterId: number;
  costCenterName: string;
  costCenterCode: string;
  totalDescendants: number;
  descendants: CostCenterDescendant[];
}

// Novos endpoints - Nível Hierárquico
export interface HierarchyLevel {
  costCenterId: number;
  costCenterName: string;
  costCenterCode: string;
  hierarchyLevel: number;
  description: string;
}
